import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';


const LazyTasks = lazy(() => import('./Tasks'));

export const Tasks: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyTasks {...props} />
	</Suspense>
);
